import { render } from "./RoomReservationList.vue?vue&type=template&id=12fddde6&scoped=true&ts=true"
import script from "./RoomReservationList.vue?vue&type=script&lang=ts"
export * from "./RoomReservationList.vue?vue&type=script&lang=ts"

import "./RoomReservationList.vue?vue&type=style&index=0&id=12fddde6&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fddde6"]])

export default __exports__